import React from 'react';
import { Link } from 'react-router-dom';
import Blog01 from '../../assets/image/blog/blog-1.jpg';
import Blog02 from '../../assets/image/blog/blog-2.jpg';
import Blog03 from '../../assets/image/blog/blog-3.jpg';

function Blog() {
  return (
    <>
      {/* Add comfortable top padding and EXTRA bottom padding to separate from next component */}
      <section className="blog-section" style={{ paddingTop: 32, paddingBottom: 120 }}>
        <div className="container">
          {/* Keep reasonable spacing around the title block (not cramped, not airy) */}
          <div className="blog-box" style={{ margin: 0, paddingTop: 8, paddingBottom: 8 }}>
            <div className="section-title-box text-center" style={{ margin: 0 }}>
              <div
                className="section-tagline"
                style={{ marginTop: 8, marginBottom: 8, lineHeight: 1.2 }}
              >
                DIRECT FROM THE BLOG POSTS
              </div>
              <h2
                className="section-title"
                style={{ marginTop: 10, marginBottom: 14, lineHeight: 1.25 }}
              >
                Checkout Latest News <br /> and Articles
              </h2>
            </div>
          </div>

          {/* Add a sensible gap before the cards */}
          <div className="row row-gutter-y-60" style={{ marginTop: 24 }}>
            <div className="col-lg-4">
              <div className="blog-card" style={{ height: '100%' }}>
                <div className="blog-card-image">
                  <img src={Blog01} className="img-fluid" alt="Local Businesses are Thriving" />
                  <Link to="/home" />
                </div>

                <div className="blog-card-date">
                  <Link to="/home" />
                </div>

                <div className="blog-card-content" style={{ paddingBottom: 12 }}>
                  <div className="blog-card-meta" style={{ marginBottom: 8 }}>
                    <span className="author">
                      <Link to="/home">John Doe</Link>
                    </span>
                    <span className="comment" style={{ marginLeft: 12 }}>
                      <Link to="/home">23 Comments</Link>
                    </span>
                  </div>

                  <h4 style={{ marginTop: 6, marginBottom: 8 }}>
                    <Link to="/home">Local Businesses are Thriving</Link>
                  </h4>
                  <p style={{ margin: 0 }}>
                    Discover how state initiatives are empowering local businesses to grow and thrive
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog-card" style={{ height: '100%' }}>
                <div className="blog-card-image">
                  <img src={Blog02} className="img-fluid" alt="Resilience for the State of GTS Green Project" />
                  <Link to="/home" />
                </div>

                <div className="blog-card-date">
                  <Link to="/home" />
                </div>

                <div className="blog-card-content" style={{ paddingBottom: 12 }}>
                  <div className="blog-card-meta" style={{ marginBottom: 8 }}>
                    <span className="author">
                      <Link to="/home">John Doe</Link>
                    </span>
                    <span className="comment" style={{ marginLeft: 12 }}>
                      <Link to="/home">16 Comments</Link>
                    </span>
                  </div>

                  <h4 style={{ marginTop: 6, marginBottom: 8 }}>
                    <Link to="/home">Resilience for the State of GTS Green Project</Link>
                  </h4>
                  <p style={{ margin: 0 }}>
                    Explore the state's Green Project, focused on sustainability and a greener future
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog-card" style={{ height: '100%' }}>
                <div className="blog-card-image">
                  <img src={Blog03} className="img-fluid" alt="Supporting Public Health" />
                  <Link to="/home" />
                </div>

                <div className="blog-card-date">
                  <Link to="/home" />
                </div>

                <div className="blog-card-content" style={{ paddingBottom: 12 }}>
                  <div className="blog-card-meta" style={{ marginBottom: 8 }}>
                    <span className="author">
                      <Link to="/home">John Doe</Link>
                    </span>
                    <span className="comment" style={{ marginLeft: 12 }}>
                      <Link to="/home">18 Comments</Link>
                    </span>
                  </div>

                  <h4 style={{ marginTop: 6, marginBottom: 8 }}>
                    <Link to="/home">Supporting Public Health</Link>
                  </h4>
                  <p style={{ margin: 0 }}>
                    Discover our initiatives to strengthen public health and ensure safer, healthier communities for all.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Blog;
